import { render, staticRenderFns } from "./RegistrationExistsUserComponent.vue?vue&type=template&id=748c669c&scoped=true"
import script from "./RegistrationExistsUserComponent.vue?vue&type=script&lang=js"
export * from "./RegistrationExistsUserComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748c669c",
  null
  
)

export default component.exports